import 'bootstrap/scss/bootstrap.scss';

import './style/app.scss';

import * as bootstrap from 'bootstrap';
import { initCountdown } from './js/countdown.js';
import { initRegistrationForm } from './js/registration.js';
import { initInvitation } from './js/invitation.js';

global.bootstrap = bootstrap;

/**
 * Check URL for terms parameter and open modal if present.
 *
 * @return {void}
 */
function initTermsModal() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('terms') === 'open') {
        const modalElement = document.querySelector('#terms-modal');
        if (modalElement) {
            const modal = new bootstrap.Modal(modalElement);
            modal.show();

            // Clean up URL after opening modal
            const url = new URL(window.location.href);
            url.searchParams.delete('terms');
            window.history.replaceState({}, '', url.pathname + url.search);
        }
    }
}

/**
 * Init all interactive modules.
 *
 * @return {void}
 */
function initApp() {
    initCountdown();
    initRegistrationForm();
    initInvitation();
    initTermsModal();
}

document.addEventListener('DOMContentLoaded', initApp, { once: true });
